export default __webpack_public_path__ + "static/media/loadingIconWhite.7fc1056a.bin";